import { Injectable } from "@angular/core";
import { URLS } from '../../../config/api.config';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from} from 'rxjs';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { map } from 'rxjs/operators';
import { Platform } from '@ionic/angular';
import { environment } from "../../../environments/environment";
import { CustomEncryption } from "../../../config/custom-encrypt";
import { CommonService } from "../../helpers/common.service";
import moment from "moment";
import { WireRequestService } from "../wire-requests/wire-requests.service";
import { StorageServiceAAA } from "../../helpers/aaa-storage.service";
import { ClientDetailsPageModule } from "../client-details/client-details.module";

@Injectable({
      providedIn: 'root'}
)
export class ClientTradesService {
	private taxPnlReport = URLS.taxPnlReport;
    private newTTTradeApi = URLS.newTTTradeApi
    private getHoldingAndSummary = URLS.getHoldingAndSummary
    private generateLinkInvestedgeStock = URLS.generateLinkInvestedgeStock
    private generateLinkInvestedgeRm = URLS.generateLinkInvestedgeRm
    private generateLinkInvestedge = URLS.generateLinkInvestedge;
    private externalConsent = URLS.getConsent;
	private nodeUrl = URLS.NodeServerUrl
	private clientHoldingMargin = URLS.clientHoldingMargin;
	private amcReportStmt = URLS.amcReport;
	private orderBook = URLS.orderBook;
	private tradeBook = URLS.tradeBook;
	private marginV2 = URLS.marginV2;
	private clientLedger1 = URLS.clientLedger1;
	private clientHolding = URLS.clientHolding;
	private clientNetPositioneq = URLS.clientNetPositioneq;
	private clientNetPositioncomm = URLS.clientNetPositioncomm
	private marketfeedsearch = URLS.marketfeedsearch;
	private consolidateHolding = URLS.consolidateHolding;
	private consolidateCommodityHolding = URLS.consolidateCommodityHolding;
	private plHolding = URLS.clientHoldingPL;
	private consolidateTradeBook = URLS.consolidateTradeBook;
	private consolidateOrderBook = URLS.consolidateOrderBook;
	private fundsPayinPayout = URLS.fundsPayinOut;
	private offlineClients = URLS.offlineClients;
	private amcData = URLS.amcData;
	private clientPortfolio = URLS.clientPortfolio;
	private familyMapp = URLS.familyMapp;
	private clientEqDetails = URLS.clientEqDetails;
	private clientMf  = URLS.clientMfDetails;
	private clientProductDetails = URLS.clientProductDetails;
	private clientFd = URLS.clientFdDetails;
	private clientBonds = URLS.clientBonds;
	private clientAif = URLS.clientAif;
	private clientPms = URLS.clientPms;
	private familyMemberDetails = URLS.familyMember;
	private clientBreakDown = URLS.clientBreakDown
	private sessionTransfer = URLS.sessionTransfer
	private realizedPL = URLS.realizedPL
	private MFPNLStatement  = URLS.MFPNLStatement;
	private getTotalEquityDividend = URLS.getTotalEquityDividend;
	private ttRefreshToken = URLS.ttRefreshToken;
    private getOffMarketTransactionRate = URLS.getOffMarketTransactionRate;
    private getOffMarketTransactionRateHistroy = URLS.getOffMarketTransactionRateHistroy;
    private SplitUpdatePriceOffMarketTransactions = URLS.SplitUpdatePriceOffMarketTransactions;
    private UpdatePriceOffMarketTransactions = URLS.UpdatePriceOffMarketTransactions;
    private getPortfolio = URLS.getPortfolio;
    private pAndLStatement = URLS.getPAndLStatement;
    
    private proxyUpdateList = [
        'Ocp-Apim-Subscription-Key',
        'key',
        'Key',
        'VID',
        'CheckSum',
        // 'CheckSumKey',
        // 'Authorization',
        'UserId',
        'Password',
        // 'X-IIFL-TOKEN',
        // 'X-IIFL-COOKIE'
    ]
    private keyMap = {
        ttKey: 'ttParams',
        marketKey: 'marketParams',
        verifyGuestKey: 'Verify_Guest_And_ExtendedApi',
        verifyRequestKey: 'VerifyRequestApi',
        tt: 'TT_OCP',
        aaaOcp: 'AAA_OCP',
        mfOcp: 'MF_OCP',
        investEdge2Ocp: 'investEdge2_OCP',
        mfCommonVid: 'mfCommonVid',
        globalChecksumKey: 'globalChecksumKey',
        clientTradesChecksum: 'clientTrades'
    }

	public options:any
	 gatewaySubscriptionKey:any ;
	 nativeHeaders = environment['nativeHeaders'];
    env:any = {
        ttParams: { key: this.keyMap.ttKey },
        marketParams: { key: this.keyMap.marketKey },
        verifyGuestandExtendedApi: { key: this.keyMap.verifyGuestKey },
        verifyRequestApi: { key: this.keyMap.verifyRequestKey },
        gatewaySubscriptionKey: {
            tt: this.keyMap.tt,
            aaa: this.keyMap.aaaOcp,
            mf: this.keyMap.mfOcp,
            investEdge2: this.keyMap.investEdge2Ocp
        },
        mfCommonVid: { vid: this.keyMap.mfCommonVid },
        generalChecksumKey: {
            globalChecksumKey: this.keyMap.globalChecksumKey,
            clientTrades: this.keyMap.clientTradesChecksum
        },
        'headersParams-optionalHeaders': {
                UserId: 'headersParams_optionalHeaders_UserId',
                Password: 'headersParams_optionalHeaders_Password'
        }
    };
	globalChecksumKey: any;
	clientTradeCheckSum: any;
	mfCommonVid: any;
    xirrScriptViceValue= URLS.xirrScriptViceValue;
    xirrValue= URLS.xirrValue;
    private httpBackend: HttpClient; 
    private signedTokenUrlofInvestEdge = URLS.signedTokenUrlofInvestEdge
 
    constructor(private httpClient: HttpClient,
        private nativeHttp: HTTP,
        private platform: Platform, private cipherText: CustomEncryption,
        private commonService: CommonService,private wireReqService: WireRequestService,private handler: HttpBackend) {
			this.httpBackend = new HttpClient(this.handler);
		
    }

    private buildConfig(url: string, extraUpdateList: string[] = []) {
        return {
            url: `${url}`,
            updateList: [...this.proxyUpdateList, ...extraUpdateList]
        }
    }

    public sendReqTOServer(params: any, config: any, reqHead: any): Observable<{}> {
        return this.httpClient.post('/api/secure/common-all-service', {
            params,
            config,
            reqHead
        })
    }

    public sendReqTOServerBackend(params: any, config: any, reqHead: any): Observable<{}> {
        // For Android app use full URL (httpBackend resolves relative paths to localhost)
        // For web use relative path (works fine with interceptors)
        const url = this.commonService.isApp()
            ? environment.apiProxyBaseUrl + '/api/secure/common-all-service'
            : '/api/secure/common-all-service';
        return this.httpBackend.post(url, {
            params,
            config,
            reqHead
        })
    }

    sendReqTOServerGet(params:any,config:any,reqHead:any): Observable<{}>{ 
		// For Android app use full URL (httpBackend resolves relative paths to localhost)
		// For web use relative path (works fine with interceptors)
		const url = this.commonService.isApp()
			? environment.apiProxyBaseUrl + '/api/secure/common-all-service-get'
			: '/api/secure/common-all-service-get';
		return this.httpBackend.post(url, {
			params,
			config,
			reqHead
		})
	}

	public getClientHoldingMargin(params: any): Observable<{}> {

        let token = this.commonService.get('JwtToken')
		let appId =  this.commonService.get('appID')
		let userType =  this.commonService.get('userType')
		let LoginId = this.commonService.get('userId1')
		return this.httpClient.post('/api/secure/getClientHoldingMargin', 
			{params,token,appId,userType,LoginId})
	}

	public getAmcStatementReport(submission: any, tokenValue: string): Observable<{}> {
		let params: any = {
			objHeader: {
				VID: this.env.mfCommonVid.vid,
				AppName: "Website",
				AppVersion: ""
			},
		};
		let appSource = null;
		if (this.platform.is('android')) {
			appSource = 12;
		} else if (this.platform.is('mobileweb') || this.platform.is('desktop')) {
			appSource = 13;
		} else if (this.platform.is('ios')) {
			appSource = 11;
		}
		submission['AppSource'] = appSource;
		Object.assign(params, submission);
		let obj: any = {
			'appID': this.commonService.get('appID') || ''
		};
		if (tokenValue) {
			obj = {
				'token': tokenValue,
				'Authorization': 'Basic ' + btoa('+Ziie2ZAI4Y=:wEBYb4fMPXalOE/vdth5Tg=='),
				'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.mf,
				'appID': this.commonService.get('appID') || ''
			}
		}
        return this.sendReqTOServer(params, this.buildConfig(this.amcReportStmt.url), Object.assign(obj, this.nativeHeaders));
	}

	public getOrderBookNow(cookievalue: any, clientID: any): Observable<{}> {
		let params = { "head": { "requestCode": "IIFLMarRQOBN01", "key": this.env.ttParams.key, "appVer": "1.0.22.0", "appName": "AAA", "osName": "Android", "LoginId": clientID,
		"userType": this.commonService.get('userType') }, "body": {} }
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
			'appID': this.commonService.get('appID') || '',
			'token' : '.ASPXAUTH=' + this.commonService.get('JwtToken'),
            UserID: 'headersParams_optionalHeaders_UserId',
            Password: 'headersParams_optionalHeaders_Password'
		};

        return this.sendReqTOServer(params, this.buildConfig(this.orderBook.url), Object.assign(obj, this.nativeHeaders));
	}

	public getTradeBook(cookievalue: any, clientID: any): Observable<{}> {
		let params = { "head": { "requestCode": "IIFLMarRQTradeBookV1", "key": this.env.ttParams.key, "appVer": "1.0.22.0", "appName": "ADVISORY ANYTIME ANYWHERE", "osName": "Android", "LoginId": clientID,
		"userType": this.commonService.get('userType') }, "body": { "ClientCode": clientID, "clientCode": clientID } }
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
			'appID': this.commonService.get('appID') || '',
			'token' : '.ASPXAUTH=' + this.commonService.get('JwtToken')
		};
		
        return this.sendReqTOServer(params, this.buildConfig(this.tradeBook.url), Object.assign(obj, this.nativeHeaders));
	}

	public getMarginV2(cookievalue: any, clientID: any): Observable<{}> {
		let params = { 
		"head": { "requestCode": "IIFLMarRQM02", "key": this.env.ttParams.key, "appVer": "1.0.22.0", "appName": "AAA", "osName": "Android", "LoginId": clientID,
		"userType": this.commonService.get('userType') },
		 "body": {} }
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
			'token': '.ASPXAUTH=' + this.commonService.get('JwtToken'),
			'appID': this.commonService.get('appID') || ''
		};
		
		
        return this.sendReqTOServer(params, this.buildConfig(this.marginV2.url), Object.assign(obj, this.nativeHeaders));
	}

	public getclientLedger1(cookievalue: any, clientID: any, previousdate: any, currentdate: any, includeMargin?: string | boolean | number): Observable<{}> {
        if (includeMargin === undefined || includeMargin === null || includeMargin === '') {
            includeMargin = 'Y';
        }
        const normalizedMargin = typeof includeMargin === 'string' ? includeMargin.trim().toUpperCase() : includeMargin;
        const includeMarginValue =
            normalizedMargin === 'Y' || normalizedMargin === 'YES' || normalizedMargin === 'TRUE' || normalizedMargin === '1' || normalizedMargin === 'ON' ||
            normalizedMargin === true || normalizedMargin === 1
                ? 'Y'
                : 'N';

            let headers={
			'Content-Type':'application/json',
			'UserID':"",
			'Password':"",
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
            'Token' : '.ASPXAUTH=' + this.commonService.get('JwtToken'),
        }
        let data: any = {
            
            "head": {
                "appName": "IIFLMarkets",
                "appVer": "1.0",
                "key": this.env.ttParams.key,
                "LoginId": this.commonService.get('userId1'),
                "osName": "Android",
                "RequestCode": "IIFLMarRQCLAAAV2"
            },
            "body": {
                "ClientCode":clientID,
                "FromDate":moment(previousdate).format('YYYYMMDD'),
                "ToDate":moment(currentdate).format('YYYYMMDD'),
                "IncludeMargin": includeMarginValue
             }
        }

        return this.sendReqTOServer(data, this.buildConfig(this.clientLedger1.url), headers);
	}

    public getclientHolding(cookievalue: any, clientID: any): Observable<{}> {
        let params = { "head": { "requestCode": "IIFLMarRQMH02", "key": this.env.ttParams.key, "appVer": "1.0", 
            "appName": "IIFLMarkets", "osName": "Android","LoginId": this.commonService.get('userId1') }, "body": { "ClientCode": clientID,} }
        let obj: any= {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
            'token' : '.ASPXAUTH=' + this.commonService.get('JwtToken'),
            'appID': this.commonService.get('appID') || ''
        };
        
        
        return this.sendReqTOServer(params, this.buildConfig(this.clientHolding.url), Object.assign(obj, this.nativeHeaders));
    }

	public getNetPositioneq(cookievalue: any, clientID: any): Observable<{}> {
		let params = { "head": { "requestCode": "IIFLMarRQGETD01", "key": this.env.ttParams.key, "appVer": "1.0.22.0", "appName": "AAA", "osName": "Android", "LoginId": clientID,
		"userType": this.commonService.get('userType') }, "body": {} }
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
			'appID': this.commonService.get('appID') || '',
			'token': '.ASPXAUTH=' + this.commonService.get('JwtToken')
		};
		
        return this.sendReqTOServer(params, this.buildConfig(this.clientNetPositioneq.url), Object.assign(obj, this.nativeHeaders));
	}

	public getNetPositioncomm(cookievalue: any, clientID: any): Observable<{}> {
		let params = { "head": { "requestCode": "IIFLMarRQGCTD01", "key": this.env.ttParams.key, "appVer": "1.0.22.0", "appName": "AAA", "osName": "Android", "LoginId": clientID,
		"userType": this.commonService.get('userType') }, "body": {} }
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
			'appID': this.commonService.get('appID') || '',
			'token': '.ASPXAUTH=' + this.commonService.get('JwtToken')
		};
		
		
        return this.sendReqTOServer(params, this.buildConfig(this.clientNetPositioncomm.url), Object.assign(obj, this.nativeHeaders));
	}

	public getconsolidateHolding(cookievalue: any, clientID: any): Observable<{}> {
		let params = { "head": { "requestCode": "IIFLMarRQMHOC", "key": this.env.ttParams.key, "appVer": "1.0.22.0", "appName": "AAA", "osName": "Android", "LoginId": clientID,
		"userType": this.commonService.get('userType') }, "body": {} }
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
			'appID': this.commonService.get('appID') || '',
			'token': '.ASPXAUTH=' + this.commonService.get('JwtToken')
		};
		
		
        return this.sendReqTOServer(params, this.buildConfig(this.consolidateHolding.url), Object.assign(obj, this.nativeHeaders));
	}

	public getconsolidateCommodityHolding(cookievalue: any, clientID: any): Observable<{}> {
		let params = { "head": { "requestCode": "IIFLMarRQHComAAA", "key": this.env.ttParams.key, "appVer": "1.0.22.0", "appName": "AAA", "osName": "Android", "LoginId": clientID,
		"userType": this.commonService.get('userType') }, "body": {} }
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
			'appID': this.commonService.get('appID') || '',
			'token': '.ASPXAUTH=' + this.commonService.get('JwtToken')
		};
		
		
        return this.sendReqTOServer(params, this.buildConfig(this.consolidateCommodityHolding.url), Object.assign(obj, this.nativeHeaders));
	}

	public getConsTradeBook(cookievalue: any, clientID: any, env:any): Observable<{}> {
	// if(this.env == undefined || this.env == null){
    //         this.env = env
    //     }
		let params = { "head": { "requestCode": "IIFLMarRQTradeBookForAAA", "key": this.env.ttParams.key, "appVer": "1.0", "appName": "IIFLMarkets", "osName": "Android", "LoginId": clientID,
		"userType": this.commonService.get('userType') }, "body": {} }
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
			'appID': this.commonService.get('appID') || '',
			'token': '.ASPXAUTH=' + this.commonService.get('JwtToken')
		};
		
		
        return this.sendReqTOServer(params, this.buildConfig(this.consolidateTradeBook.url), Object.assign(obj, this.nativeHeaders));
	}

	public getConsOrderBook(clientID: any,env?:any): Observable<{}> {
		// if(this.env == undefined || this.env == null){
        //     this.env = env
        // }
	let params = { 
            "body": { 
                "AdminCode": clientID 
            }, 
            "head": { 
            "appName": "IIFLMarkets", 
            "appVer": "1.0",
            "key": this.env.ttParams.key,
            "osName": "Android",
            "requestCode": "IIFLMarRQOBFAAAV2",
            "LoginId": this.commonService.get('userId1')
        } 
    }
	let obj = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
			'appID': this.commonService.get('appID') || '',
			'token': '.ASPXAUTH=' + this.commonService.get('JwtToken')
		};
		// if (cookievalue) {
		// 	obj = {
		// 		'token': cookievalue
		// 	}
		// }
		// this.headersParams['token'] =  '.ASPXAUTH=' + this.commonService.get('JwtToken');
        return this.sendReqTOServer(params, this.buildConfig(this.consolidateOrderBook.url), Object.assign(obj, this.nativeHeaders, this.options));
	}

    public getHoldingPl(cookievalue: any, clientID: any): Observable<{}> {
        let params = { "head": { "RequestCode": "IIFLMarRQHPLS03", "key": 
            this.env.ttParams.key, "appVer": "1.0", "appName": 
            "IIFLMarkets", "osName": "Android", "LoginId": this.commonService.get('userId1')}, 
            "body": {"ClientCode": clientID} }
        let obj: any = {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
            'appID': this.commonService.get('appID') || '',
            'token': '.ASPXAUTH=' + this.commonService.get('JwtToken')
        };
        
        return this.sendReqTOServer(params, this.buildConfig(this.plHolding.url), Object.assign(obj, this.nativeHeaders, this.options));
    }

	public getMarketFeedData(array: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "IIFLMarRQMFMU77",
				"key": this.env.ttParams.key,
				"appVer": "1.0",
				"appName": "IIFLMarkets",
				"osName": "Android",
				"LoginId": this.commonService.get('userId1')
			},
			"body": {
				 "clientCode": this.commonService.get('userId1'),
				"reFreshRate": "H",
				"MarketFeedData": array,
				"ClientLoginType": 0,
			}
		}
		
		let obj = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
			'appID': this.commonService.get('appID') || '',
			'token': '.ASPXAUTH=' + this.commonService.get('JwtToken'),
            UserId: 'headersParams_optionalHeaders_UserId',
            Password: 'headersParams_optionalHeaders_Password'
		}
        return this.sendReqTOServer(params, this.buildConfig(this.marketfeedsearch.url),obj);
	}

    public getLtpValue(passObj: any): Observable<{}> {
        let params = { 
                "head": {
				"RequestCode": "IIFLMarRQMFMU77",
				"key": this.env.ttParams.key,
				"appVer": "1.0",
				"appName": "IIFLMarkets",
				"osName": "Android",
				"LoginId": this.commonService.get('userId1')
			},

           body:{ "clientCode": this.commonService.get('userId1'),
            "MarketFeedData": [{ "Exch": passObj.Exch, "ExchType": passObj.ExchType, 
                "ScripCode": passObj.ScripCode}], 
        "ClientLoginType": 0,  "RefreshRate": "H"}
    }
        let obj = {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
            'appID': this.commonService.get('appID') || '',
            'token': '.ASPXAUTH=' + this.commonService.get('JwtToken'),
            UserId: 'headersParams_optionalHeaders_UserId',
            Password: 'headersParams_optionalHeaders_Password'
        }
        return this.sendReqTOServer(params, this.buildConfig(this.marketfeedsearch.url), obj);
    }
    public getArrayLtpValue(array: any): Observable<{}> {

        let params = {"head": {
				"RequestCode": "IIFLMarRQMFMU77",
				"key": this.env.ttParams.key,
				"appVer": "1.0",
				"appName": "IIFLMarkets",
				"osName": "Android",
				"LoginId": this.commonService.get('userId1')
			},body:{"clientCode": this.commonService.get('userId1'), "Count": array.length, 
            "MarketFeedData": array,
             "ClientLoginType": 0, "RefreshRate": "H"}}
        let obj = {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey?.tt,
            'appID': this.commonService.get('appID') || '',
            'token': '.ASPXAUTH=' + this.commonService.get('JwtToken'),
            UserId: 'headersParams_optionalHeaders_UserId',
            Password: 'headersParams_optionalHeaders_Password'
        }
        return this.sendReqTOServer(params, this.buildConfig(this.marketfeedsearch.url), obj);
    }

    public getPayinPayout(cookievalue: any, bodyParams: any): Observable<{}> {
		const checkSumKey = this.cipherText.generateCheckSumKey()
		const checkSumString = bodyParams.RMCode + "_" + bodyParams.ClientCode + "_" + bodyParams.FrmDate + "_" + bodyParams.ToDate + "_" + checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
		bodyParams.ClientCode = this.cipherText.createChecksum(bodyParams.ClientCode,checkSumKey)
		bodyParams.RMCode = this.cipherText.createChecksum(bodyParams.RMCode,checkSumKey)
        let params = {"head": {
			"requestcode": "MFRQLO01",
			"key": this.env.verifyGuestandExtendedApi.key,
			"appver": "1.0.4.0",
			"appname": 'AAA',
			"osname": "Android",
			"CheckSumKey":checkSumKey,
        	"CheckSum":checkSumString
        }
		,"body": bodyParams}
        let obj: any = {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
            'appID': this.commonService.get('appID') || '',
        };
        if (cookievalue) {
            obj['token'] = cookievalue;
        }   

        return this.sendReqTOServer(params, this.buildConfig(this.fundsPayinPayout.url), Object.assign(obj, this.nativeHeaders, this.options))
    }

	getOfflineMfClients(cookievalue: any, bodyParams: any): Observable<{}> {
		let params = { "head": { "RequestCode": "CVUpdateLead01", "Key": this.env.verifyRequestApi.key, "AppVer": "1.0.4.0", "AppName": this.offlineClients.appName, "OsName": "Android",
		"userType": this.commonService.get('userType') }, "body": bodyParams }
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
			'appID': this.commonService.get('appID') || '',
            'UserID': this.env.headersParams_optionalHeaders_UserId,
            'Password': this.env.headersParams_optionalHeaders_Password
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
        return this.sendReqTOServer(params, this.buildConfig(this.offlineClients.url),obj)
	}

	getAMCData(cookievalue: any): Observable<{}> {
		let params = { "objHeader": { "VID": this.env.mfCommonVid.vid, "AppName": "Website", "AppVersion": "", "AppSource": null }, "AppSource": "2", "OrderRequesterCode": "FDEM1" };
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.mf,
			'appID': this.commonService.get('appID') || '',
            'UserID': this.env.headersParams_optionalHeaders_UserId,
            'Password': this.env.headersParams_optionalHeaders_Password
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
            
		}
        return this.sendReqTOServer(params, this.buildConfig(this.amcData.url), obj)
	}
	
	public getClientPortfolio(cookievalue: any, clientCode: any,consolidate: any, childCode?: any, userId?: any, clientType?: any): Observable<{}> {
		let params = 
		{
			"body": {
			  "ClientCodeParent": clientCode,
			  "ClientCodeChild": childCode ? childCode : "",
			  "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",//userId,
			  "ConsoliDated": consolidate,
			    "ClientType": clientType
			},
			"head": {
			  "RequestCode": "APIBO52UCVDWFY",
			  "Key": this.env.verifyGuestandExtendedApi.key,
			  "AppVer": "01",
			  "AppName": "AAA",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			}
		  } 
		let headers = new HttpHeaders()
		headers = headers.delete('token');
		headers = headers.set('token', cookievalue);
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);

     	return this.sendReqTOServer(params, this.buildConfig(this.clientPortfolio.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}

	public getFamilyMapping(cookievalue?: any, clientCode?: any,userId?: any, clientType?: any): Observable<{}> {
		let params = 
		{
			"body": {
				"ClientCode": clientCode,
				"PartnerCode": userId,
				"ClientType": clientType,
			},
			"head": {
			  "RequestCode": "APIBO52UCVDWFY",
			  "Key": this.env.verifyGuestandExtendedApi.key,
			  "AppVer": "01",
			  "AppName": "AAA",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			}
		}	

		// let headers = new HttpHeaders()
		// headers = headers.delete('token');
		// headers = headers.set('token', cookievalue);
		// headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKeyang);
		
     	return this.sendReqTOServer(params, this.buildConfig(this.familyMapp.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}


	public getClientEqDetails(cookievalue: any, clientCode: any, consolidate: any, childCode?: any, userId?: any, clientType?: any): Observable<{}> {
		let params = 
		{
			"body": {
			  "ClientCodeParent": clientCode,
			  "ClientCodeChild": childCode ? childCode : "",
			  "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",//userId,
			  "ConsoliDated": consolidate,
			  "AsonDate": moment(new Date()).format('YYYYMMDD'),
			  "ClientType": clientType
			},	
			"head": {
			  "RequestCode": "APIBO52UCVDWFY",
			  "Key": this.env.verifyGuestandExtendedApi.key,
			  "AppVer": "01",
			  "AppName": "AAA",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			}
		}

		let headers = new HttpHeaders()
		headers = headers.delete('token');
		headers = headers.set('token', cookievalue);
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);

        return this.sendReqTOServer(params, this.buildConfig(this.clientEqDetails.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}

	public getClientMfDetails(cookievalue: any, clientCode: any,consolidate: any, childCode?: any, userId?: any, clientType?: any): Observable<{}> {
		let params = 
		{
			"body": {
			 "ClientCodeParent": clientCode,
			  "ClientCodeChild": childCode ? childCode : "",
			  "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "", //userId,
			  "ConsoliDated": consolidate,
			  "AsonDate": moment(new Date()).format('YYYYMMDD'),
			  "ClientType": clientType
			  
			},
			"head": {
			  "RequestCode": "APIBO52UCVDWFY",
			  "Key": this.env.verifyGuestandExtendedApi.key,
			  "AppVer": "01",
			  "AppName": "AAA",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			}
		}

		let headers = new HttpHeaders()
		headers = headers.delete('token');
		headers = headers.set('token', cookievalue);
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);

        return this.sendReqTOServer(params, this.buildConfig(this.clientMf.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}

	public getProductSummary(cookievalue: any, clientCode: any, consolidate: any, childCode: any, userId: any, clientType?: any): Observable<{}> {
		let params = 
		{
			"body": {
			"ClientCodeParent": clientCode,
			"ClientCodeChild": childCode ? childCode : "",
			"PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",	//userId,
			"ConsoliDated": consolidate,
			  "ClientType": clientType
			},
			"head": {
			  "RequestCode": "APIBO52UCVDWFY",
			  "Key": this.env.verifyGuestandExtendedApi.key,
			  "AppVer": "01",
			  "AppName": "AAA",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			}
		  }

		let headers = new HttpHeaders()
		headers = headers.delete('token');
		headers = headers.set('token', cookievalue);
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);

        return this.sendReqTOServer(params, this.buildConfig(this.clientProductDetails.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}

	public getFixDepoDetails(cookievalue: any, clientCode: any, consolidate: any, childCode: any, userId: any, clientType?: any): Observable<{}> {
		let params = 
		{
			"body": {
			  "ClientCodeParent": clientCode,
			  "ClientCodeChild": childCode ? childCode : "",
			  "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",	//userId,
			  "ConsoliDated": consolidate,
			  "AsonDate": moment(new Date()).format('YYYYMMDD'),
			  "ClientType":clientType
			},
			"head": {
			  "RequestCode": "APIBO52UCVDWFY",
			  "Key": this.env.verifyGuestandExtendedApi.key,
			  "AppVer": "01",
			  "AppName": "AAA",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			}
		  }

		let headers = new HttpHeaders()
		headers = headers.delete('token');
		headers = headers.set('token', cookievalue);
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);

        return this.sendReqTOServer(params, this.buildConfig(this.clientFd.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}

	public getBondDetails(cookievalue: any, clientCode: any, consolidate: any, childCode: any, userId: any, clientType?: any): Observable<{}> {
		let params = 
		{
			"body": {
			  "ClientCodeParent": clientCode,
			  "ClientCodeChild": childCode ? childCode : "",
			  "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",// userId,
			  "ConsoliDated": consolidate,
			  "AsonDate": moment(new Date()).format('YYYYMMDD'),
			  "ClientType": clientType
			},
			"head": {
			  "RequestCode": "APIBO52UCVDWFY",
			  "Key": this.env.verifyGuestandExtendedApi.key,
			  "AppVer": "01",
			  "AppName": "AAA",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			}
		  }

		let headers = new HttpHeaders()
		headers = headers.delete('token');
		headers = headers.set('token', cookievalue);
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);

        return this.sendReqTOServer(params, this.buildConfig(this.clientBonds.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}

	public getAifDetails(cookievalue: any, clientCode: any, consolidate: any, childCode: any, userId: any, clientType?: any): Observable<{}> {
		let params = 
		{
			"body": {
				"ClientCodeParent": clientCode,
				"ClientCodeChild": childCode ? childCode : "",
				"PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",	//userId,
				"ConsoliDated": consolidate,
				"AsonDate": moment(new Date()).format('YYYYMMDD'),
				"ClientType": clientType
			},
			"head": {
				"RequestCode": "APIBO52UCVDWFY",
				"Key": this.env.verifyGuestandExtendedApi.key,
				"AppVer": "01",
				"AppName": "AAA",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			}
		}

		let headers = new HttpHeaders()
		headers = headers.delete('token');
		headers = headers.set('token', cookievalue);
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);

        return this.sendReqTOServer(params, this.buildConfig(this.clientAif.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}

	public getPmsDetails(cookievalue: any, clientCode: any, consolidate: any, childCode: any, userId: any, clientType?: any): Observable<{}> {
		let params = 
		{
			"body": {
			  "ClientCodeParent": clientCode,
			  "ClientCodeChild": childCode ? childCode : "",
			  "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",	//userId,
			  "ConsoliDated": consolidate,
			  "AsonDate": moment(new Date()).format('YYYYMMDD'),
			  "ClientType": clientType
			},
			"head": {
			  "RequestCode": "APIBO52UCVDWFY",
			  "Key": this.env.verifyGuestandExtendedApi.key,
			  "AppVer": "01",
			  "AppName": "AAA",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			}
		  }

		let headers = new HttpHeaders()
		headers = headers.delete('token');
		headers = headers.set('token', cookievalue);
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);

        return this.sendReqTOServer(params, this.buildConfig(this.clientPms.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}


    public getMemberDetails(passObj: any,cookievalue?: any): Observable<{}> {
        const checkSumKey = this.cipherText.generateCheckSumKey()
		const checkSumString = 
        passObj.OTP ? 
        passObj.MakerID + "_" + passObj.FamilyName + "_" + passObj.OTP + "_" + checkSumKey + "_" + moment(new Date()).format('DDMMYYYY'):
        passObj.MakerID + "_" + passObj.FamilyName + "_" + checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
		const checkSum = this.cipherText.createChecksum(checkSumString,this.globalChecksumKey)
		passObj.FamilyName = this.cipherText.createChecksum(passObj.FamilyName,checkSumKey)
		passObj.MakerID = this.cipherText.createChecksum(passObj.MakerID,checkSumKey)
		passObj.OTP = passObj.OTP !== "" ? this.cipherText.createChecksum(passObj.OTP,checkSumKey) : ""
        let params = 
        {
            "body": passObj,
            "head": {
                "RequestCode": "APIBO52UCVDWFY",
                "Key": this.env.verifyGuestandExtendedApi.key,
                "AppVer": "01",
                "AppName": this.familyMemberDetails.appName,
                "OsName": "Android",
                "CheckSum":checkSumString,
                "CheckSumKey":checkSumKey
            }
        } 

		let headers = new HttpHeaders()
		headers = headers.delete('token');
		headers = headers.set('token', cookievalue);
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);

        return this.sendReqTOServer(params, this.buildConfig(this.familyMemberDetails.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}

	
	public getClientBreakDownDetails(clientCode: any,passObj: any,cookievalue?: any,clientType?: any): Observable<{}> {
		let params = 
		{
			"body": {
				"PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",//userId
				"ClientCode": clientCode,
				"ScripCode": passObj['value'],
				"Product": passObj['type'],
				"ClientType": clientType
			},
			"head": {
				"RequestCode": "APIBO52UCVDWFY",
				"Key": this.env.verifyGuestandExtendedApi.key,
				"AppVer": "01",
				"AppName": "AAA",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			}
		}

		let headers = new HttpHeaders()
		headers = headers.delete('token');
		headers = headers.set('token', cookievalue);
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);

        return this.sendReqTOServer(params, this.buildConfig(this.clientBreakDown.url), {
            token: cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        })
	}

	public getSessionToken(clientCode: any,formToken: any): Observable<{}> {
		let params = 
		{
			"head": {
				"requestCode": "IIFLMarRQSAFCBL01",
				"key": this.env.ttParams.key,
				"appVer": "5.20.0.0",
				"appName": "IIFLMarkets",
				"osName": "Android",
				"LoginId": clientCode,
				"userType": this.commonService.get('userType')
			},
			"body": {
				"formAuthToken": formToken
			}
		}	
		let headers = new HttpHeaders()
		// headers = headers.delete('token');
		headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.tt);
        return this.sendReqTOServer(params, this.buildConfig(this.sessionTransfer.url), {
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.tt
        })
	}

	public getRealizedPl(cookievalue: any, realizedPlParams: any, env:any) {
		let params =  {
			"head": {"RequestCode": "PnLSummaryRealized",
				"Key": this.env.verifyRequestApi.key,"AppVer": "1.0.4.0","OsName": "Android","AppName": "AAA",
			"userType": this.commonService.get('userType')},
            "body": {"ClientCode": realizedPlParams.clientCode,
                "FromDate": realizedPlParams.fromDate,"ToDate":realizedPlParams.ToDate,"Product" : realizedPlParams.product,
			"PartnerCode" : this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
		}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
			'appID': this.commonService.get('appID') || '',
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
        return this.sendReqTOServer(params, this.buildConfig(this.realizedPL.url), Object.assign(obj, this.nativeHeaders));
	}

	public getMFPNLStatement(cookievalue: any,  clientCode: any, previousdate: any, currentdate: any, userId:any, clientType?: any): Observable<{}> {
		let stringValue = clientCode + "_" + moment(new Date()).format('DDMMYYYY');
		const checkSumValue = this.cipherText.createChecksum(stringValue,this.env.generalChecksumKey.clientTrades);
		let params: any = 
		{
			"body": {
				"ClientCode": this.cipherText.aesEncrypt(clientCode),
				"FromDate": previousdate,
				"ToDate": currentdate,
				"PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
				"ClientType": clientType
				},
			"head": {
			"RequestCode": "ProfileDetailsV1",
       		"Key": this.env.verifyGuestandExtendedApi.key,
       		"AppName": "AAA",
       		"AppVer": "1.0.4.0",
       		"OsName": "Android",
			"CheckSumKey": "clientTrades",
    		"CheckSum": stringValue
			}
		}
		
		// let headers = new HttpHeaders()
		// headers = headers.delete('token');
		// headers = headers.set('token', cookievalue);
		// headers = headers.set('Ocp-Apim-Subscription-Key', this.env.gatewaySubscriptionKey.aaa);
        let obj: any = {
			'Ocp-Apim-Subscription-Key' : "AAA_OCP",
			'appID': this.commonService.get('appID') || '',
            'token': cookievalue
		};
        let	config={
				url: this.MFPNLStatement.url,
				createWithCustomKey:true,
					updateList:['Key','Ocp-Apim-Subscription-Key','CheckSumKey','CheckSum']
				}
		return  this.sendReqTOServer(params, config, obj);
        // return this.sendReqTOServer(params, this.buildConfig(this.MFPNLStatement.url), {
        //     token: cookievalue,
        //     'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa
        // })
	}
	
	public GetTotalEquityDividend(cookievalue:string,  clientCode:string, fromDate:string, toDate:string, consolidate:string): Observable<{}> {
		let stringValue = clientCode + "_" + moment(new Date()).format('DDMMYYYY');
		// const checkSumValue = this.cipherText.createChecksum(stringValue,this.env.generalChecksumKey.clientTrades);
		let params = 
		{
			"body": {
			"ClientCode": this.cipherText.aesEncrypt(clientCode),
			"FromDate": fromDate,
			"ToDate": toDate,
			"Consolidate": consolidate,
			"PartnerCode" : this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
			},
			"head": {
			"RequestCode": "ProfileDetailsV1",
			"Key": this.env.verifyGuestandExtendedApi.key,
			"AppName": this.getTotalEquityDividend.appName,
			"AppVer": "1.0.4.0",
			"OsName": "Android",
			"CheckSumKey": 'clientTrades',
    		"CheckSum": stringValue
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "AAA_OCP",
			'appID': this.commonService.get('appID') || '',
            'token': cookievalue
		};
		
        let	config={
				url: this.getTotalEquityDividend.url,
				createWithCustomKey:true,
					updateList:['Key','Ocp-Apim-Subscription-Key','CheckSumKey','CheckSum']
				}
		return  this.sendReqTOServer(params, config, obj);
        
	}

public callNodeServerForPdf(itemChecked: any, isBrokingClient: boolean, portfolioData: any, productChartData: any, familyMappList: any,
        portfolioToken: any, clientCode: any, fromDateReq: any, toDateReq: any, clientDetails: any, displayRelation:any,clientTypeNo:any,
        realizedClientCode:any,isExternal:boolean, changeToken:any,cookievalue:any,displayClientCode:any,xirrDetails:any
    ) {
        // let childCode= ""
        // if(this.commonService.get("userId1") === null){
        //     childCode =   clientCode 
			
        //     let selfCode:any;
		// 	if(familyMappList.length === 1){
		// 		selfCode = familyMappList;
		// 	} else {
		// 		selfCode = familyMappList.filter((temp:any)=> temp.Relation.toUpperCase() === 'SELF' || temp.Relation === '')
		// 	}
        //     clientCode = this.cipherText.aesEncrypt(selfCode[0].ClientCode)
        // }
		// let pnlCode:any
		// let checkSumValue:any
        // if(itemChecked.includes('pl') == true){
        //    pnlCode = this.cipherText.aesEncrypt(realizedClientCode)
        //   const  stringValue = realizedClientCode + "_" + moment(new Date()).format('DDMMYYYY');
        //    checkSumValue = this.cipherText.createChecksum(stringValue,this.env.generalChecksumKey.clientTrades);
        // }

        // let pdfGenerateBody:any;
        // const consolidate = displayRelation === 'FAMILY'? "1" : "0"

        //         let xirrParentCode = ""
        // if(familyMappList.length > 1){
        //     let selfCode = familyMappList.filter((temp:any)=> temp.Relation.toUpperCase() === 'SELF' || temp.Relation === '')
        //     xirrParentCode = selfCode[0].ClientCode
        // } else {
        //     let selfCode = familyMappList.filter((temp:any)=> temp.Relation.toUpperCase() === 'SELF' || temp.Relation === '')
        //     xirrParentCode = selfCode[0].ClientCode
        // }
        
        //  const body = {
        //                         "ClientCodeParent": xirrParentCode,
        //                         "ClientCodeChild": displayClientCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.commonService.get("userId1") : "",  //userId,
        //                         "ConsoliDated": consolidate,
        //                     }
        //                     const secerateParams = this.createCheckSumFromDetails(body)

        // if(isExternal == true){
        //     const clientType = this.commonService.get('userType')
        //     const startDateNew = moment(fromDateReq).format('YYYY/MM/DD').split('/').join('')
        //     const toDateNew = moment(toDateReq).format('YYYY/MM/DD').split('/').join('')
        //     pdfGenerateBody = {
        //         "urls": [
        //             {
        //                 "name": "commodity",
        //                 "url": this.realizedPL.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "head": {
        //                         "RequestCode": "PnLSummaryRealized",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppName": "AAA",
        //                         "AppVer": "01",
        //                         "OsName": "Android",
        //                         "userType": clientType,
		// 						"CheckSum": checkSumValue,
        //                         "CheckSumKey": this.clientTradeCheckSum
        //                     },
        //                     "body": {
        //                         "ClientCode": pnlCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "FromDate": startDateNew,
        //                         "ToDate": toDateNew,
        //                         "Product": "commodity"
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "f&o",
        //                 "url": this.realizedPL.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "head": {
        //                         "RequestCode": "PnLSummaryRealized",
        //                         "Key": this.env.verifyRequestApi.key,
        //                         "AppName": "AAAWEB",
        //                         "AppVer": "1.0.4.0",
        //                         "OsName": "Android",
        //                         "userType": clientType,
		// 						"CheckSum": checkSumValue,
        //                         "CheckSumKey": this.clientTradeCheckSum
        //                     },
        //                     "body": {
        //                         "ClientCode": pnlCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "FromDate": startDateNew,
        //                         "ToDate": toDateNew,
        //                         "Product": "f&o"
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "cash",
        //                 "url": this.realizedPL.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "head": {
        //                         "RequestCode": "PnLSummaryRealized",
        //                         "Key": this.env.verifyRequestApi.key,
        //                         "AppName": "AAAWEB",
        //                         "AppVer": "1.0.4.0",
        //                         "OsName": "Android",
        //                         "userType": clientType,
		// 						"CheckSum": checkSumValue,
        //                         "CheckSumKey": this.clientTradeCheckSum
        //                     },
        //                     "body": {
        //                         "ClientCode": pnlCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "FromDate": startDateNew,
        //                         "ToDate": toDateNew,
        //                         "Product": "cash"
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "currency",
        //                 "url": this.realizedPL.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "head": {
        //                         "RequestCode": "PnLSummaryRealized",
        //                         "Key": this.env.verifyRequestApi.key,
        //                         "AppName": "AAAWEB",
        //                         "AppVer": "1.0.4.0",
        //                         "OsName": "Android",
        //                         "userType": clientType,
		// 						"CheckSum": checkSumValue,
        //                         "CheckSumKey": this.clientTradeCheckSum
        //                     },
        //                     "body": {
        //                         "ClientCode": pnlCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "FromDate": startDateNew,
        //                         "ToDate": toDateNew,
        //                         "Product": "currency"
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "mfPnlStatment",
        //                 "url": this.MFPNLStatement.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "body": {
        //                         "ClientCode": clientCode,
        //                         "FromDate": moment(fromDateReq).format('DD/MM/YYYY'),
        //                         "ToDate": moment(toDateReq).format('DD/MM/YYYY'),
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "ClientType": ""
        //                     },
        //                     "head": {
        //                         "RequestCode": "ProfileDetailsV1",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppName": "AAA",
        //                         "AppVer": "1.0.4.0",
        //                         "OsName": "Android",
		// 						"CheckSum": checkSumValue,
        //                         "CheckSumKey": this.clientTradeCheckSum
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "mfData",
        //                 "url": this.clientMf.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "body": {
        //                         "ClientCodeParent": clientCode,
        //                         "ClientCodeChild": childCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "ConsoliDated": consolidate,
        //                         "AsonDate": moment(new Date()).format('YYYYMMDD'),
        //                         "ClientType": ""
        //                     },
        //                     "head": {
        //                         "RequestCode": "APIBO52UCVDWFY",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppVer": "01",
        //                         "AppName": "AAA",
        //                         "OsName": "Android",
        //                         "userType": clientType
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "ClientProductSummary",
        //                 "url": this.clientProductDetails.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "body": {
        //                         "ClientCodeParent": clientCode,
        //                         "ClientCodeChild": childCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "ConsoliDated": consolidate,
        //                         "ClientType": clientTypeNo
        //                     },
        //                     "head": {
        //                         "RequestCode": "APIBO52UCVDWFY",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppVer": "01",
        //                         "AppName": "AAA",
        //                         "OsName": "Android",
        //                         "userType": clientType
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "GetClientBondDetails",
        //                 "url": this.clientBonds.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "body": {
        //                         "ClientCodeParent": clientCode,
        //                         "ClientCodeChild": childCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "ConsoliDated": consolidate,
        //                         "AsonDate": moment(new Date()).format('YYYYMMDD'),
        //                         "ClientType": ""
        //                     },
        //                     "head": {
        //                         "RequestCode": "APIBO52UCVDWFY",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppVer": "01",
        //                         "AppName": "AAA",
        //                         "OsName": "Android",
        //                         "userType": clientType
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "ClientEquityDetails",
        //                 "url": this.clientEqDetails.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "body": {
        //                         "ClientCodeParent": clientCode,
        //                         "ClientCodeChild": childCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "ConsoliDated": consolidate,
        //                         "AsonDate": moment(new Date()).format('YYYYMMDD'),
        //                         "ClientType": ""
        //                     },
        //                     "head": {
        //                         "RequestCode": "APIBO52UCVDWFY",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppVer": "01",
        //                         "AppName": "AAA",
        //                         "OsName": "Android",
        //                         "userType": clientType
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "GetClientFDDetails",
        //                 "url": this.clientFd.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "body": {
        //                         "ClientCodeParent": clientCode,
        //                         "ClientCodeChild": childCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "ConsoliDated": consolidate,
        //                         "AsonDate": moment(new Date()).format('YYYYMMDD'),
        //                         "ClientType": clientTypeNo
        //                     },
        //                     "head": {
        //                         "RequestCode": "APIBO52UCVDWFY",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppVer": "01",
        //                         "AppName": "AAA",
        //                         "OsName": "Android",
        //                         "userType": clientType
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "ClientAIFDetails",
        //                 "url": this.clientAif.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "body": {
        //                         "ClientCodeParent": clientCode,
        //                         "ClientCodeChild": childCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "ConsoliDated": consolidate,
        //                         "AsonDate": moment(new Date()).format('YYYYMMDD'),
        //                         "ClientType": ""
        //                     },
        //                     "head": {
        //                         "RequestCode": "APIBO52UCVDWFY",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppVer": "01",
        //                         "AppName": "AAA",
        //                         "OsName": "Android",
        //                         "userType": clientType
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "ClientPMSDetails",
        //                 "url": this.clientPms.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "body": {
        //                         "ClientCodeParent": clientCode,
        //                         "ClientCodeChild": childCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "ConsoliDated": consolidate,
        //                         "AsonDate": moment(new Date()).format('YYYYMMDD'),
        //                         "ClientType": ""
        //                     },
        //                     "head": {
        //                         "RequestCode": "APIBO52UCVDWFY",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppVer": "01",
        //                         "AppName": "AAA",
        //                         "OsName": "Android",
        //                         "userType": clientType
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "GetTotalEquityDividend",
        //                 "url": this.getTotalEquityDividend.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {
        //                     "body": {
        //                         "ClientCode": clientCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
        //                         "FromDate": moment(fromDateReq).format('YYYY/MM/DD'),
        //                         "ToDate": moment(toDateReq).format('YYYY/MM/DD'),
        //                         "Consolidate": consolidate
        //                     },
        //                     "head": {
        //                         "RequestCode": "ProfileDetailsV1",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppName": "AAA",
        //                         "AppVer": "1.0.4.0",
        //                         "OsName": "Android",
		// 						"CheckSum": checkSumValue,
        //                         "CheckSumKey": this.clientTradeCheckSum
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "familyHoldingDist",
        //                 "url": this.clientPortfolio.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {

        //                     "body": {
        //                         "ClientCodeChild": childCode,
        //                         "ClientCodeParent": clientCode,
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",//userId,
        //                         "ConsoliDated": consolidate,
        //                         "ClientType": ""
        //                     },
        //                     "head": {
        //                         "RequestCode": "APIBO52UCVDWFY",
        //                         "Key": this.env.verifyGuestandExtendedApi.key,
        //                         "AppVer": "01",
        //                         "AppName": "AAA",
        //                         "OsName": "Android",
        //                         "userType": this.commonService.get('userType')
        //                     }
        //                 }
        //             },
        //             {
        //                 "name": "getScriptViceXirr",
        //                 "url": this.xirrScriptViceValue.url,
        //                 "headers": {
        //                     "Ocp-Apim-Subscription-Key": this.env.gatewaySubscriptionKey.aaa,
        //                     "token": portfolioToken,
        //                     "APPID": this.commonService.get('appID') || '',
        //                     "UserAgent": "AAA",
        //                     "Content-Type": "application/json"
        //                 },
        //                 "body": {

        //                     "head": {
        //                         "RequestCode": "CVUpdateLead01",
        //                         "Key": "",
        //                         "AppName": "AAA",
        //                         "AppVer": "01",
        //                         "OsName": "Android",
        //                         "CheckSum": secerateParams.checkSum,
        //                         "CheckSumKey": secerateParams.checkSumKey
        //                     },
        //                     "body": {
        //                         "ClientCodeParent": this.cipherText.createChecksum(xirrParentCode,secerateParams.checkSumKey),
        //                         "ClientCodeChild":this.cipherText.createChecksum(displayClientCode,secerateParams.checkSumKey),
        //                         "PartnerCode": this.commonService.get("userId1") ? this.cipherText.createChecksum(this.commonService.get("userId1"),secerateParams.checkSumKey) : "",  //userId,
        //                         "ConsoliDated": consolidate,
        //                          "fromDate": "",
        //                         "toDate": "",
        //                     }
        //                 }
        //             }
        //         ],
        //         "xirrDetails":xirrDetails,
        //         "itemChecked": itemChecked,
        //         "isBrokingClient": isBrokingClient,
        //         "displayRelation": displayRelation,
        //         "productChartData": productChartData,
        //         "personalDetails": clientDetails,
        //         "portfolioData": portfolioData,
        //         "FamillyMapp": familyMappList,
        //         "isPnl": true,
        //         "isExternal":false
        //     }
        //     if (itemChecked.includes('pl') == false) {
        //         pdfGenerateBody.urls.splice(0, 5);
        //         pdfGenerateBody.isPnl = false
        //     }
        // } else {
        //     // const url = isSummary === false ? 'holding-details/'+clientId : 'holding-summary/'+clientId ;
        //     const clientToken = changeToken === false ? this.cipherText.aesEncrypt(('.ASPXAUTH='+this.commonService.get('portfolioToken'))).trim() : ''
        //     pdfGenerateBody = {
        //         "urls": [this.getHoldingAndSummary.url] ,
        //         "itemChecked": itemChecked,
        //         "isBrokingClient": isBrokingClient,
        //         "displayRelation": displayRelation,
        //         "productChartData": productChartData,
        //         "personalDetails": clientDetails,
        //         "portfolioData": portfolioData,
        //         "FamillyMapp": familyMappList,
        //         "isPnl": false,
        //         "isExternal":true,
        //         "consolidate":consolidate,
        //         "signedToken":cookievalue,
		// 		'iifl_token': changeToken === true ? this.cipherText.aesEncrypt(this.commonService.get('jwt_token')) :this.cipherText.aesEncrypt(cookievalue) ,
		//         'iifl_cookie': changeToken === true ?  this.cipherText.aesEncrypt(this.commonService.get('brokerageToken')) :clientToken
        //     }
        // }

        // let obj: any = {
        //     'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
        //     'appID': this.commonService.get('appID') || ''
        // };
        let portfolioToken2 = changeToken === false ? this.cipherText.aesEncrypt(('.ASPXAUTH='+this.commonService.get('portfolioToken'))).trim() : ''
    let userId1 = localStorage.getItem('userId1') ;
    let appID = this.commonService.get('appID') || '';
    let userType= this.commonService.get('userType') || '';
            let jwt_token = this.commonService.get('jwt_token')
        let brokerageToken = this.commonService.get('brokerageToken')
        return this.httpClient.post('/api/secure/call-node-server',{
            itemChecked, isBrokingClient, portfolioData, productChartData, familyMappList,
        portfolioToken, clientCode, fromDateReq, toDateReq, clientDetails, displayRelation,clientTypeNo,
             jwt_token, brokerageToken,
        realizedClientCode,isExternal, changeToken,cookievalue,displayClientCode,xirrDetails,userId1, appID,userType,portfolioToken2
        },{responseType: 'blob'} )
        // return  this.sendReqTOServer(pdfGenerateBody, this.buildConfig(this.nodeUrl.url), Object.assign(obj));
    }
	investEdgeLink(){
        return this.wireReqService.getinvestcurrentTime()   
    }


    public getConsent(body:any,clientId:any,changeToken:any) {  
        const clientToken = changeToken === false ? this.cipherText.aesEncrypt(('.ASPXAUTH='+this.commonService.get('portfolioToken'))).trim() : ''
        let obj: any = {
            // 'Authorization' : 'Bearer '+cookievalue,
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.investEdge2,
            'X-IIFL-TOKEN': changeToken === true ? this.cipherText.aesEncrypt(localStorage.getItem('jwt_token')) : "",
		    'X-IIFL-COOKIE': changeToken === true ?  this.cipherText.aesEncrypt(this.commonService.get('brokerageToken')) :clientToken
        };
        return this.sendReqTOServerGet(body, this.buildConfig(this.externalConsent.url+clientId),obj);
    }


    public generateExternalConnectLink(cookievalue:any,body:any,changeToken:any) {
        const clientToken = changeToken === false ? this.cipherText.aesEncrypt(('.ASPXAUTH='+this.commonService.get('portfolioToken'))).trim() : ''

        let obj: any = {
            'Authorization' : 'Bearer '+cookievalue,
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.investEdge2,
            'X-IIFL-TOKEN': changeToken === true ? this.cipherText.aesEncrypt(this.commonService.get('jwt_token')) :this.cipherText.aesEncrypt(cookievalue) ,
		    'X-IIFL-COOKIE': changeToken === true ?  this.cipherText.aesEncrypt(this.commonService.get('brokerageToken')) :clientToken
        };
        return this.sendReqTOServerBackend(body, this.buildConfig(this.generateLinkInvestedge.url), obj);
    }


    public generateExternalConnectLinkRm(cookievalue:any,body:any, changeToken?:any) {
        const clientToken = changeToken === false ? this.cipherText.aesEncrypt(('.ASPXAUTH='+this.commonService.get('portfolioToken'))).trim() : ''

        let obj: any = {
            'Authorization' : 'Bearer '+cookievalue,
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.investEdge2,
            'X-IIFL-TOKEN': changeToken === true ? this.cipherText.aesEncrypt(this.commonService.get('jwt_token')) :this.cipherText.aesEncrypt(cookievalue) ,
		    'X-IIFL-COOKIE': changeToken === true ?  this.cipherText.aesEncrypt(this.commonService.get('brokerageToken')) :clientToken
        };
        return this.sendReqTOServerGet({}, this.buildConfig(this.generateLinkInvestedgeRm.url+body), Object.assign(obj, this.nativeHeaders));
    }


     public refreshExternalStockData(cookievalue:any,body:any, changeToken?:any){
        const clientToken = changeToken === false ? this.cipherText.aesEncrypt(('.ASPXAUTH='+this.commonService.get('portfolioToken'))).trim() : ''

        let obj: any = {
            'Authorization' : 'Bearer '+cookievalue,
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.investEdge2,
            'X-IIFL-TOKEN': changeToken === true ? this.cipherText.aesEncrypt(this.commonService.get('jwt_token')) :this.cipherText.aesEncrypt(cookievalue),
		    'X-IIFL-COOKIE': changeToken === true ?  this.cipherText.aesEncrypt(this.commonService.get('brokerageToken')) :clientToken
        };
        return this.sendReqTOServer(body, this.buildConfig(this.generateLinkInvestedgeStock.url), obj);
     }
     
     
public fetchExternalHoildingandSummary(cookievalue:any,clientId:any,isSummary:boolean,changeToken?:any){
        const clientToken = changeToken === false ? this.cipherText.aesEncrypt(('.ASPXAUTH='+this.commonService.get('portfolioToken'))).trim() : ''

            const url = isSummary === false ? 'holding-details/'+clientId : 'holding-summary/'+clientId ;
            let obj: any = {
                'Authorization' : 'Bearer '+cookievalue,
                'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.investEdge2,
                 'X-IIFL-TOKEN': changeToken === true ? this.cipherText.aesEncrypt(this.commonService.get('jwt_token')) : this.cipherText.aesEncrypt(cookievalue),
		    	'X-IIFL-COOKIE': changeToken === true ?  this.cipherText.aesEncrypt(this.commonService.get('brokerageToken')) : clientToken
            };
            return this.sendReqTOServerGet({}, this.buildConfig(this.getHoldingAndSummary.url+url), obj);
     }

	 public getTtRefreshToken(cookievalue:any,loginedUser:any){
        
        const params = {
            "head": {
                "RequestCode": "IIFLMarRRFAUAAA",
                "key": this.env.ttParams.key,
                "appVer": "1.0",
                "appName": "IIFLMarket",
                "osName": "Android",
                "LoginId": loginedUser.substring(0, 8)
            },
            "body": {
                
            }
        }
        let obj: any = {
            'token' : cookievalue,
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
            'appID': this.commonService.get('appID') || ''
        }
        return this.sendReqTOServer(params, this.buildConfig(this.ttRefreshToken.url), Object.assign(obj, this.nativeHeaders));
     }

	     getTaxPnlReport(body:any,cookievalue:any,checkSumKey: any){
        const params = {
            "head": {
                "RequestCode":"CVUpdateLead01",
                "Key":this.env.verifyGuestandExtendedApi.key,
                "AppVer": "01",
				"AppName": "AAA",
				"OsName": "Android",
				"CheckSumKey": checkSumKey,
            },
            body: body
        }
        let obj: any = {
            'Token': cookievalue,
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa,
            'appID': this.commonService.get('appID') || '',
        };
		return this.sendReqTOServer(params, this.buildConfig(this.taxPnlReport.url), Object.assign(obj, this.nativeHeaders));
    }


    public newTTApiCall( clientID: any,type: any): Observable<{}> {
        let params = { "head": { "requestCode": "IIFLMarRQCLHGD01",
             "key": this.env.ttParams.key, "appVer": "1.0", 
             "appName": this.newTTTradeApi.appName, "osName": "Android", 
             "LoginId": this.commonService.get('userId1') }, "body": {"ClientCode": clientID,
        "RequestType": type} }
        let obj: any= {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.tt,
            'token' : '.ASPXAUTH=' + this.commonService.get('JwtToken'),
            'appID': this.commonService.get('appID') || ''
        };
        
        
		return this.sendReqTOServer(params, this.buildConfig(this.newTTTradeApi.url), Object.assign(obj, this.nativeHeaders));
    }

    createCheckSumFromDetails(bodyParams:any){
        const checkSumKey = this.cipherText.generateCheckSumKey()
        let checkSumString = '';
        const array = Object.keys(bodyParams);
        array.forEach(function (param) {
            if (bodyParams[param]) {
                checkSumString += bodyParams[param] + "_";
            }
        })
        checkSumString += checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
        // const checkSum = this.cipherText.createChecksum(checkSumString, this.globalChecksumKey)
        return { checkSumKey: checkSumKey, checkSum: checkSumString };
    }

    getXirrValue(cookievalue: any, clientCode: any, consolidate: any, childCode: any,familyMappList:any,displayClientCode:any){
        let parentCode = ''
        if(familyMappList.length > 1){
            childCode =   clientCode 
            let selfCode = familyMappList.filter((temp:any)=> temp.Relation.toUpperCase() === 'SELF' || temp.Relation === '')
            parentCode = selfCode[0].ClientCode
        } else {
            childCode =   clientCode 
            let selfCode = familyMappList.filter((temp:any)=> temp.Relation.toUpperCase() === 'SELF' || temp.Relation === '')
            parentCode = selfCode[0].ClientCode
        }

        const body = {
                                "ClientCodeParent": parentCode,
                                "ClientCodeChild": displayClientCode,
                                "PartnerCode": this.commonService.get("userId1") ? this.commonService.get("userId1") : "",  //userId,
                                "ConsoliDated": consolidate,
                            }
        const secerateParams = this.createCheckSumFromDetails(body)
        const params = {
                            "head": {
                                "RequestCode": "CVUpdateLead01",
                                "Key": this.env.verifyGuestandExtendedApi.key,
                                "AppName": "AAA",
                                "AppVer": "01",
                                "OsName": "Android",
                                "CheckSum": secerateParams.checkSum,
                                "CheckSumKey": secerateParams.checkSumKey
                            },
                            "body": {
                                "ClientCodeParent": this.cipherText.createChecksum(parentCode,secerateParams.checkSumKey),
                                "ClientCodeChild": this.cipherText.createChecksum(displayClientCode,secerateParams.checkSumKey),
                                "PartnerCode": this.commonService.get("userId1") ? this.cipherText.createChecksum(this.commonService.get("userId1"),secerateParams.checkSumKey) : "",  //userId,
                                "ConsoliDated": consolidate,
                                 "fromDate": "",
                                "toDate": "",
                            }
                        }
        let obj: any= {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
            'Key': this.env.verifyGuestandExtendedApi.key,
            'token' : cookievalue,
            'appID': this.commonService.get('appID') || ''
        };
        
        
		return this.sendReqTOServer(params, this.buildConfig(this.xirrValue.url), Object.assign(obj, this.nativeHeaders));
    }

    getXirrValueByScript(cookievalue: any, clientCode: any, consolidate: any, childCode: any,familyMappList:any,displayClientCode:any){
       let parentCode = ''
        if(familyMappList.length > 1){
            childCode =   clientCode 
            let selfCode = familyMappList.filter((temp:any)=> temp.Relation.toUpperCase() === 'SELF' || temp.Relation === '')
            parentCode = selfCode[0].ClientCode
        } else {
            childCode =   clientCode 
            let selfCode = familyMappList.filter((temp:any)=> temp.Relation.toUpperCase() === 'SELF' || temp.Relation === '')
            parentCode = selfCode[0].ClientCode
        }

        const body = {
                                "ClientCodeParent": parentCode,
                                "ClientCodeChild": displayClientCode,
                                "PartnerCode": this.commonService.get("userId1") ? this.commonService.get("userId1") : "",  //userId,
                                "ConsoliDated": consolidate,
                            }
        const secerateParams = this.createCheckSumFromDetails(body)
        const params = {
                            "head": {
                                "RequestCode": "CVUpdateLead01",
                                "Key": this.env.verifyGuestandExtendedApi.key,
                                "AppName": "AAA",
                                "AppVer": "01",
                                "OsName": "Android",
                                "CheckSum": secerateParams.checkSum,
                                "CheckSumKey": secerateParams.checkSumKey
                            },
                            "body": {
                                "ClientCodeParent": this.cipherText.createChecksum(parentCode,secerateParams.checkSumKey),
                                "ClientCodeChild":this.cipherText.createChecksum(displayClientCode,secerateParams.checkSumKey),
                                "PartnerCode": this.commonService.get("userId1") ? this.cipherText.createChecksum(this.commonService.get("userId1"),secerateParams.checkSumKey) : "",  //userId,
                                "ConsoliDated": consolidate,
                                 "fromDate": "",
                                "toDate": "",
                            }
                        }
        let obj: any= {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
            'Key': this.env.verifyGuestandExtendedApi.key,
            'token' : cookievalue,
            'appID': this.commonService.get('appID') || ''
        };
        
        
		return this.sendReqTOServer(params, this.buildConfig(this.xirrScriptViceValue.url), obj);
    }

 getDecryptedValue(data:any, key:any, iv:any){
   let  config={
        decryptName:'getDecryptedValue'
    }
    return this.httpClient.post('/api/secure/decryptGuestLoginChecksum-service', { data, key, iv,config })
 }

 OffMarketTransactionRate(cookievalue: any, clientID: any): Observable<{}> {
		const checkSumKey = this.cipherText.generateCheckSumKey()
		const checkSumString = clientID + "_" + checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
		const ClientCode = this.cipherText.createChecksum(clientID,checkSumKey)
		let params = {
            "head": {
			"requestcode": "AAA",
			"key": this.env.verifyGuestandExtendedApi.key,
			"appver": "01",
			"appname": 'AAA',
			"osname": "Android",
			"CheckSumKey":checkSumKey,
        	"CheckSum":checkSumString
        },
        "body": {
                "ClientCode": ClientCode
			}
        }
        let obj: any = {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
            'appID': this.commonService.get('appID') || '',
        };
        if (cookievalue) {
            obj['token'] = cookievalue;
        }   

        return this.sendReqTOServer(params, this.buildConfig(this.getOffMarketTransactionRate.url), Object.assign(obj, this.nativeHeaders, this.options))
}

OffMarketTransactionRateHistroy(cookievalue: any, clientID: any): Observable<{}> {
		const checkSumKey = this.cipherText.generateCheckSumKey()
		const checkSumString = clientID + "_" + checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
		const ClientCode = this.cipherText.createChecksum(clientID,checkSumKey)
		let params = {
            "head": {
			"requestcode": "AAA",
			"key": this.env.verifyGuestandExtendedApi.key,
			"appver": "01",
			"appname": 'AAA',
			"osname": "Android",
			"CheckSumKey":checkSumKey,
        	"CheckSum":checkSumString
        },
        "body": {
                "ClientCode": ClientCode
			}
        }
        let obj: any = {
            'Ocp-Apim-Subscription-Key' : this.env.gatewaySubscriptionKey.aaa,
            'appID': this.commonService.get('appID') || '',
        };
        if (cookievalue) {
            obj['token'] = cookievalue;
        }   

        return this.sendReqTOServer(params, this.buildConfig(this.getOffMarketTransactionRateHistroy.url), Object.assign(obj, this.nativeHeaders, this.options))
}

splitUpdatePriceOffMarketTransactions(cookievalue: any,bodyParams: any[]): Observable<{}> {
        const checkSumKey = this.cipherText.generateCheckSumKey();
        const checkSumString =  checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
        const encryptedBodyParams = JSON.parse(JSON.stringify(bodyParams || [])).map((item: any) => ({
            ...item,
            ClientCode: item?.ClientCode ? this.cipherText.createChecksum(item.ClientCode, checkSumKey) : item?.ClientCode,
        }));
        const encryptRequest = {
            "head": {
                "requestcode": "AAA",
                "key": this.env.verifyGuestandExtendedApi.key,
                "appver": "01",
                "appname": "AAA",
                "osname": "Android",
                "CheckSumKey": checkSumKey,
                "CheckSum": checkSumString
            },
            "body": encryptedBodyParams
        };



        let obj: any = {
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa,
            'appID': this.commonService.get('appID') || '',
        };
        if (cookievalue) {
            obj['token'] = cookievalue;
        }
        const reqHead = Object.assign({}, obj, this.nativeHeaders, this.options);
        let config = this.buildConfig(this.SplitUpdatePriceOffMarketTransactions.url)
        return this.httpClient.post('/api/secure/encryptrequest-service', {
            encryptRequest,config,reqHead,obj
        })
}

UpdatePriceOffMarket(cookievalue: any,bodyParams: any[]): Observable<{}> {
        const checkSumKey = this.cipherText.generateCheckSumKey();
        const checkSumString =  checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
        const encryptedBodyParams = JSON.parse(JSON.stringify(bodyParams || [])).map((item: any) => ({
            ...item,
            ClientCode: item?.ClientCode ? this.cipherText.createChecksum(item.ClientCode, checkSumKey) : item?.ClientCode,
        }));
        const encryptRequest = {
            "head": {
                "requestcode": "AAA",
                "key": this.env.verifyGuestandExtendedApi.key,
                "appver": "01",
                "appname": "AAA",
                "osname": "Android",
                "CheckSumKey": checkSumKey,
                "CheckSum": checkSumString
            },
            "body": encryptedBodyParams
        };



        let obj: any = {
            'Ocp-Apim-Subscription-Key': this.env.gatewaySubscriptionKey.aaa,
            'appID': this.commonService.get('appID') || '',
        };
        if (cookievalue) {
            obj['token'] = cookievalue;
        }
        const reqHead = Object.assign({}, obj, this.nativeHeaders, this.options);
        let config = this.buildConfig(this.UpdatePriceOffMarketTransactions.url)
        return this.httpClient.post('/api/secure/encryptrequest-service', {
            encryptRequest,config,reqHead,obj
        })
}
  signedTokenforInvestEdge(body: any) {
    const apiUrl = '/api/secure/invest-edge-token';

    const config = {
      url: this.signedTokenUrlofInvestEdge.url,
    };

    const params = { body };

    if (this.commonService.isApp()) {
      this.nativeHttp.setDataSerializer('json');

      return from(
        this.nativeHttp.post(
          apiUrl,
          { config, params },
          this.nativeHeaders || {}
        )
      ).pipe(
        map((response: any) => JSON.parse(response.data))
      );
    }

    return this.httpClient.post(apiUrl, { config, params });
  }

    getMfPortfolioDetails(clientCode: any, consolidate: any, childCode?: any, userId?: any, clientType?: any): Observable<{}> {
        let passObj = {
            "ClientCodeParent": clientCode,
            "ClientCodeChild": childCode ? childCode : "",
            "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
            "ConsoliDated": consolidate,
            "AsonDate": moment(new Date()).format('YYYYMMDD'),
            "ClientType": clientType
        }

        // console.log('getMfPortfolioDetails', passObj)
        const config = {
            url: this.getPortfolio.url,
        }

        const params = {
            body: {
                LoginID: clientCode,
            }
        }
        const reqHead = {
            token: this.commonService.get('jwt_token'),
        }

        return this.httpClient.post('/api/secure/mf-data-service', { config, params, reqHead });
    }


    public getPAndLStatementDetails(cookievalue: any, clientCode: any, previousdate: any, currentdate: any, userId: any, clientType?: any): Observable<{}> {
        const formatDate = (date: string) => {
            const [day, month, year] = date.split("/");
            return `${year}-${month}-${day}`;
        };

        const passObj = {
            "ClientCode": this.cipherText.aesEncrypt(clientCode),
            FromDate: formatDate(previousdate),
            ToDate: formatDate(currentdate),
            "PartnerCode": this.commonService.get("userId1") ? this.cipherText.aesEncrypt(this.commonService.get("userId1")) : "",
            "ClientType": clientType
        }

        // console.log('getPAndLStatementDetails', passObj)
        const config = {
            url: this.pAndLStatement.url,
        }
        const params = {
            body: {
                LoginID: clientCode,
                FromDate: passObj.FromDate,
                ToDate: passObj.ToDate,
            }
        }
        const reqHead = {
            token: this.commonService.get('jwt_token'),
        }

        return this.httpClient.post('/api/secure/mf-data-service', { config, params, reqHead });
    }


}